
export const SEED_POSTS = [
  {
    id: "post-1",
    slug: "choose-the-right-career-after-class-10",
    title: "How to Choose the Right Career Stream After Class 10",
    excerpt: "Science, commerce, or arts? A structured way for students and parents to think beyond peer pressure.",
    body: `Choosing a stream after Class 10 is one of the earliest big decisions in a student's journey. Yet most decisions are made under peer pressure, family expectations, or incomplete information.

At Crescet Edustreams, we recommend a three-step approach:

1. Run a scientific assessment via CounselNest to map your aptitude, interests, and personality.
2. Talk to a certified career counsellor who can interpret the results in your context.
3. Pair the chosen stream with realistic college and career paths using AdmissionsNest.

Streams are not destinies — but they do open or close doors. Pick the door that fits the student, not the trend.`,
    category: "Career Counselling",
    cover_image: "https://images.unsplash.com/photo-1569173675610-42c361a86e37?auto=format&fit=crop&w=1400&q=70",
    read_minutes: 5,
    author: "Crescet Edustreams Editorial",
    published_at: "2026-03-01T00:00:00.000Z",
  },
  {
    id: "post-2",
    slug: "study-abroad-2026-checklist",
    title: "The 2026 Study-Abroad Checklist: 12 Things You Must Track",
    excerpt: "From SOPs to scholarship deadlines — the complete admissions checklist for overseas aspirants.",
    body: `An overseas application is a multi-month project. Most students underestimate the timeline and lose scholarship opportunities. Track these key milestones from at least 12 months out:

- Target country shortlist with cost-of-living estimates
- Standardized test plan (IELTS / TOEFL / GRE / GMAT / SAT)
- 8-12 college shortlist (reach, target, safe)
- Recommenders identified and briefed early
- SOP first draft + multiple review rounds
- Scholarship calendar (institutional + external grants)
- Financial proof and visa documentation checklist

AdmissionsNest counsellors run dedicated sprint check-ins against this list to ensure zero missed deadlines.`,
    category: "Admissions",
    cover_image: "https://images.unsplash.com/photo-1495995424756-6a5a3f9e7543?auto=format&fit=crop&w=1400&q=70",
    read_minutes: 7,
    author: "Crescet Edustreams Editorial",
    published_at: "2026-03-05T00:00:00.000Z",
  },
  {
    id: "post-3",
    slug: "psychometric-vs-dmit-which-assessment",
    title: "Psychometric vs DMIT: Which Assessment Should You Choose?",
    excerpt: "Two popular tools, two very different things they measure. Here's how to pick the right one.",
    body: `Psychometric assessments measure aptitude, personality, interest, and learning style through validated psychological questionnaires. DMIT (Dermatoglyphics Multiple Intelligence Test) analyses fingerprint ridge patterns to indicate innate cognitive distribution.

- Use psychometric assessments for: stream selection, career fit, and study-skill profiling.
- Use DMIT for: an additional lens on innate strengths, especially for younger learners.

Neither replaces the other. Most CounselNest counsellors combine both, alongside a structured interview, before recommending a definitive career trajectory.`,
    category: "Assessments",
    cover_image: "https://images.unsplash.com/photo-1637589316488-6d4c41b335cd?auto=format&fit=crop&w=1400&q=70",
    read_minutes: 4,
    author: "Crescet Edustreams Editorial",
    published_at: "2026-03-08T00:00:00.000Z",
  },
  {
    id: "post-4",
    slug: "finding-the-right-tutor",
    title: "Finding the Right Tutor: 5 Questions Parents Should Ask",
    excerpt: "The best tutor is not always the most expensive. Use these 5 filters before you decide.",
    body: `Connecting with the right educator can completely change a student's confidence in challenging subjects. Before booking sessions, keep these 5 filters in mind:

1. Subject-specific teaching track record (not just generic tutoring years)
2. Alignment with your specific curriculum and examination pattern (CBSE, ICSE, IB, Cambridge)
3. Clear monthly benchmark reviews to measure conceptual progress
4. Regular, transparent feedback cadence with parents
5. Structured revision drills leading up to board and competitive exams

TutorsNest curates verified subject educators to match each student's exact learning pace and goals.`,
    category: "Tutoring",
    cover_image: "https://images.unsplash.com/photo-1522661067900-ab829854a57f?auto=format&fit=crop&w=1400&q=70",
    read_minutes: 5,
    author: "Crescet Edustreams Editorial",
    published_at: "2026-03-10T00:00:00.000Z",
  },
];

export const blogService = {
  /**
   * Fetch all published blog posts.
   */
  async getPosts() {
    return SEED_POSTS;
  },

  /**
   * Fetch a single blog post by slug.
   */
  async getPostBySlug(slug) {
    const post = SEED_POSTS.find((p) => p.slug === slug);
    if (!post) throw new Error("Post not found");
    return post;
  },
};

export default blogService;
